/**
 * Максимальная длина для имени держателя карты.
 * @constant {number}
 */
export const MAX_LENGTH_CARDHOLDER_NAME = 24;

/**
 * Максимальная длина для поля имени/фамилии на латинице.
 * @constant {number}
 */
export const MAX_LENGTH_LATIN = 24;

/**
 * Минимальная длина для поля имени/фамилии на латинице.
 * @constant {number}
 */
export const MIN_LENGTH_LATIN = 2;

/**
 * Идентификатор канала для MYFIN.
 * @constant {string}
 */
export const MYFIN_CHANNEL = '0006';
